<template>
<div >
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div v-for="empleados in data.item.empleadosEspecialistas" :key="empleados.idEmpleadoCoordinadorEspecialidad">
        <br />
        <p class="letraMayusculaMinuscula"> 
            {{ empleados.nombreCoordinadorEspecialidad }} - {{empleados.descripcionEstatusReplica}}
        </p> 
    </div> 
        
    <br/>
    <br/>
    <br/>
</div>
</template>

<script>
export default {
    name: "ListaEspecialistasReplica",
    props: {
        data: Object,
        resource: Object
    },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
    methods: {
       
    }
}
</script>
